module.exports = __webpack_public_path__ + "media/metronic/_theme/media/demos/demo9/bg-450-aa31ef8c0591c4475570f33c3afe1d94.jpg";